import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { AuthProvider } from 'contexts/AuthContext';
import { NotificationProvider } from 'contexts/NotificationContext';
import InstallPWA from 'components/InstallPWA';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <AuthProvider>
        <NotificationProvider>
          <ScrollTop>
            <RouterProvider router={router} />
            <InstallPWA />
          </ScrollTop>
        </NotificationProvider>
      </AuthProvider>
    </ThemeCustomization>
  );
}
